import { site } from '@yola/ws-sdk';
import store from 'src/js/store';

const BROADCAST_CHANNEL_PREFIX = 'yola-editor_';

const getBroadcastChannelName = () => {
  const state = store.getState();
  const siteId = site.selectors.getSiteId(state);
  return `${BROADCAST_CHANNEL_PREFIX}${siteId}`;
};

export default getBroadcastChannelName;
